import { motion } from "framer-motion";
import Layout from "../components/Layout";
import PageWrapper from "../components/PageWrapper";
import ProjectCard from "../components/ProjectCard";

function Projects() {
  const projects = [
    {
      title: "TheIndiArt",
      description:
        "A fully developed end-to-end e-commerce platform for handmade artistry, focusing on secure auth, efficient APIs, a user-friendly UI, and a dependable backend.",
      tech: "React, Tailwind CSS, Node.js, MongoDB",
      github: "#",
      live: "https://www.theindiart.com",
    },
    {
      title: "Coming Soon",
      description:
        "...",
      tech: "#",
      github: "https://github.com/siddharthriot/civiceye",
      live: "#",
    },
    {
      title: "Coming Soon",
      description:
        "...",
      tech: "#",
      github: "https://github.com/SiddharthRiot/WomenSafetyApp",
      live: "#",
    },
    {
      title: "Portfolio",
      description:
        "A dark, motion-first portfolio designed with typography, animation, and system thinking.",
      tech: "React, Tailwind, Framer Motion",
      github: "https://github.com/siddharthriot/portfolio",
      live: "https://siddharthriot-portfolio.vercel.app/",
    },
  ];

  return (
    <PageWrapper>
      <Layout>
        <motion.div
          className="max-w-5xl select-none cursor-default"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <h1 className="font-heading text-3xl md:text-4xl font-semibold mb-12">
            Projects
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((project, i) => (
              <ProjectCard key={i} project={project} />
            ))}
          </div>
        </motion.div>
      </Layout>
    </PageWrapper>
  );
}

export default Projects;
